import { icons } from 'assets';
import { RouteAwareCrumbs } from 'Components/shared/breadcrumbs';
import TableDisplay from 'Components/shared/table';
import Text from 'Components/shared/text';
import { Status, TransactionType } from 'Components/shared/transactions';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetUsersTransactions } from 'services/transactionService';
import { flagsMap } from 'utils/constants/maps';
import { convertDate } from 'utils/stringServices';
import styles from './history.module.css';

const Formatter = new Intl.NumberFormat('en-US');
const NumberFormatter = new Intl.NumberFormat('en-US');



const tableStructure = {
    0:{
        renderItem: (item) => {
            return <Text style={{fontWeight:"300"}} variant="sm">Date <br />
             {convertDate(item.timestamp)}</Text>
        },
        cellStyle:{
            minWidth:"90px"
        }
    },
    1:{
        renderItem: (item) => {
            return <Text style={{fontWeight:"300"}} color="secondary" variant="sm">Exchange <br /><img width="18px" src={ flagsMap[item?.fromCurrency] || icons.nigeria_small} alt="country flag"/>
            <span style={{paddingLeft:"8px", color:"var(--primary-text)"}}>{NumberFormatter.format(item.fromAmount) +" "+ item.fromCurrency?.toUpperCase?.() }</span></Text>
        },
        cellStyle:{
            minWidth:"142px",
            wordBreak:"keep-all"
        }
    },
    2:{
        renderItem: (item) => {
            return <TransactionType type="swap" />
        }
    },
    3:{
        renderItem: (item) => {
            return <Text style={{fontWeight:"300"}} color="secondary" variant="sm">To: <br /><img width="18px" src={flagsMap[item.toCurrency]} alt="country flag"/>
            <span style={{paddingLeft:"8px", color:"var(--primary-text)"}}>{NumberFormatter.format(item.toAmount || 0) +" "+ item.toCurrency?.toUpperCase?.() }</span>
            </Text>
        },
        cellStyle:{
            minWidth:"142px"
        }
    },
    4:{
        renderItem: (item) => {
            return <Text style={{fontWeight:"300"}} color="secondary" variant="sm">Price <br /> 
                1 {item.toCurrency?.toUpperCase?.()} = 
                {` ${item.rate} ${item.toCurrency?.toUpperCase?.()}`}
            </Text>
        },
        cellStyle:{
            minWidth:"142px"
        }
    },
    
}

const CurrencySwap = () => {
    const navigate = useNavigate();
    const [selectedTab, setSelectedTab] = useState(0);
    const {data, isLoading} = useGetUsersTransactions("swap");
    const handleChange = (e, tabIndex) => {
        setSelectedTab(tabIndex);
    }
    const NameMap = {
        "/transaction-history/currency-swap":"Currency Swap Transactions",
        "/transaction-history": "Transaction History"
    }
    return (
        <div className={styles.root}>
            <Text variant="lg" tag="h1" style={{fontWeight:"700"}}>Currency Swap Transactions</Text>
            <RouteAwareCrumbs nameMap={NameMap} />
            
            <div className={styles.contentContainer}>
                <Text variant="md2" tag="h2" style={{ fontWeight:"700",marginBottom:"24px"}}>Transactions</Text>
                <TableDisplay data={data || []}  column={tableStructure}emptyComponent={"No Data present"}/>
            </div>
        </div>
    )
}

export default CurrencySwap;